import { Download } from '@gympass/yoga-icons';
import { useFlag } from '@unleash/proxy-client-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { getCareMatrixProfile } from 'utils/helpers/careMatrix';
import { FeatureToggle } from 'utils/unleash/toggles';

import { useModals } from 'context';
import Chat from 'public/assets/icons/chat.svg';

import Tooltip from 'components/Tooltip';

import { HeaderUserInfoProps } from './types';

import * as S from './styles';

export const HeaderUserInfo: React.FC<HeaderUserInfoProps> = ({ user }) => {
  const { openModal } = useModals();
  const navigate = useNavigate();
  const intl = useIntl();

  const isPatientNotesEnabled = useFlag(FeatureToggle.PatientRecords);
  const isCareMatrixProfileEnabled = useFlag(FeatureToggle.CareMatrixProfile);

  const handleClickChat = () => {
    navigate(`/care-provider/chat?cognito_id=${user?.cognitoID}`);
  };

  function handleClickDocDownload() {
    openModal('docDownload', {
      props: {
        cognitoId: user?.cognitoID,
      },
    });
  }

  return (
    <S.HeaderInfoContainer data-testid="header-user-info">
      <S.HeaderLabel>
        {user?.fullName}{' '}
        {isCareMatrixProfileEnabled && user?.care_profile && (
          <S.HeaderUserProfileTag
            variant={getCareMatrixProfile(user.care_profile)?.variant}
          >
            <Tooltip
              position="bottom-center"
              description={intl.formatMessage({
                id: getCareMatrixProfile(user.care_profile)?.description,
              })}
            >
              <S.TooltipTextContainer>
                <FormattedMessage
                  id={getCareMatrixProfile(user.care_profile)?.profile_name}
                />
              </S.TooltipTextContainer>
            </Tooltip>
          </S.HeaderUserProfileTag>
        )}
      </S.HeaderLabel>
      <S.ButtonsContainer>
        {isPatientNotesEnabled && (
          <S.HeaderButtonDocDownload
            onClick={() => handleClickDocDownload()}
            icon={Download}
          >
            <FormattedMessage id="HEADER_USER_INFO.BUTTON.DOWNLOAD" />
          </S.HeaderButtonDocDownload>
        )}
        <S.HeaderButtonChat
          data-testid="header-chat-button"
          icon={Chat}
          onClick={handleClickChat}
        >
          Chat
        </S.HeaderButtonChat>
      </S.ButtonsContainer>
    </S.HeaderInfoContainer>
  );
};
